export function OutlineUserPlusIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.93395 10.9968C11.1422 10.9968 12.9324 9.20667 12.9324 6.99841C12.9324 4.79015 11.1422 3 8.93395 3C6.7257 3 4.93555 4.79015 4.93555 6.99841C4.93555 9.20667 6.7257 10.9968 8.93395 10.9968Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9341 8.00195V14.002"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9341 11.002H20.9341"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.93089 14.002H12.9373C14.0413 14.002 14.9341 14.8948 14.9341 15.9988V21.0004H2.93408V15.9988C2.93408 14.8948 3.82688 14.002 4.93089 14.002Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
